/* eslint-disable */
import Vue from 'vue'

export const getDeviceOptions = params => {
  return Vue.fetch.post('/apiv1/hr/device/revisableOptionDetails', params)
}
/**
 * 获取timezone
 */
export const getTimeZone = params => {
  return Vue.fetch.post('/apiv1/device/dstConfig/getTimezoneAndTzid', params)
}

export const getDeviceEmployeList = params => {
  return Vue.fetch.post(
    '/apiv1/hr/employee/device/findEmployeesByDevice',
    params
  )
}
/**
 * 获取公司设备列表
 */
export const findByCmpId = params => {
  return Vue.fetch.post('/apiv1/hr/device/findByCmpId', params)
}

/**
 * 根据角色权限获取设备
 * @param {} params
 */
export const getDeviceList = params => {
  return Vue.fetch.post('/apiv1/hr/device/deviceList', params)
}

/**
 * 添加企业设备
 * @param {} params
 */
export const addDevice = params => {
  return Vue.fetch.post('/apiv1/hr/device/add', params)
}

/**
 * 修改設備信息
 */
export const updateDevice = params => {
  return Vue.fetch.post('/apiv1/hr/device/update', params)
}

/** *********设备与组织架构的关系 start ************/

/**
 * 获取组织架构已经绑定的设备
 */
export const getOrgDevices = params => {
  return Vue.fetch.post('/apiv1/hr/organization/device/findBindDevice', params)
}

/**
 * 获取未绑定的设备列表
 * @param {*} params
 */
export const getUnBindDeviceList = params => {
  return Vue.fetch.post(
    '/apiv1/hr/organization/device/findUnBindDevice',
    params
  )
}

/**
 * 组织架构绑定设备
 * @param {*} params
 */
export const orgBindDevices = params => {
  return Vue.fetch.post('/apiv1/hr/organization/device/create', params)
}

/**
 * 组织架构解绑设备
 */
export const orgUnbindDevice = params => {
  return Vue.fetch.post('/apiv1/hr/organization/device/unbindDevice', params)
}

/** *********设备与组织架构的关系 End ************/

/** *********设备与人员的关系 Start ************/

/**
 * 获取人员已经绑定的设备
 * @param {*} params
 */
export const getEmployeeDeviceList = params => {
  return Vue.fetch.post('/apiv1/hr/employee/device/findBindDevice', params)
}

/**
 * 获取人员未绑定的设备
 * @param {*} params
 */
export const getEmployeeUnBindDeviceList = params => {
  return Vue.fetch.post('/apiv1/hr/employee/device/findUnBindDevice', params)
}

/**
 * 设置人员绑定设备
 * @param {*} params
 */
export const setEmployeeBindDevices = params => {
  return Vue.fetch.post(
    '/apiv1/hr/employee/device/bindDevices2Employees',
    params
  )
}

/**
 * 设置人员解绑绑定设备
 * @param {*} params
 */
export const setEmployeeUnBindDevices = params => {
  return Vue.fetch.post(
    '/apiv1/hr/employee/device/unbindDevices2Employees',
    params
  )
}

/** *********设备与人员的关系 End ************/
export const deleteDevice = params => {
  return Vue.fetch.post('/apiv1/hr/device/delete', params)
}

export const getDeviceDetails = params => {
  return Vue.fetch.post('/apiv1/hr/device/deviceDetails', params)
}

/**
 *禁用设备
 * @param {*} params
 */
export const disabledEvent = params => {
  return Vue.fetch.post('/apiv1/hr/device/disable', params)
}

/**
 *启用设备
 * @param {*} params
 */
export const enableEvent = params => {
  return Vue.fetch.post('/apiv1/hr/device/enable', params)
}

/**
 *重启设备
 * @param {*} params
 */
export const rebootEvent = params => {
  return Vue.fetch.post('/apiv1/hr/device/reboot', params)
}

/**
 *重新上传考勤记录
 * @param {*} params
 */
export const uploadAttDataEvent = params => {
  return Vue.fetch.post('/apiv1/hr/device/reloadAttInfo', params)
}

/**
 *重新上传员工信息
 * @param {*} params
 */
export const uploadUserInfoEvent = params => {
  return Vue.fetch.post('/apiv1/hr/device/reloadEmpInfo', params)
}

/**
 *刷新人员信息到设备
 * @param {*} params
 */
export const synDataEvent = params => {
  return Vue.fetch.post('/apiv1/hr/employee/device/refreshData2Device', params)
}

export const queryDeviceLog = params => {
  return Vue.fetch.post('/apiv1/hr/device/queryDeviceLog', params)
}

export const setOptions = params => {
  return Vue.fetch.post('/apiv1/hr/device/updateOptions', params)
}

export const loadDeviceOptions = params => {
  return Vue.fetch.post('/apiv1/hr/device/optionDetails', params)
}

// 获取最近固件版本
export const getNewest = params => {
  return Vue.fetch.post('/apiv1/ufo/newest', params)
}

// 固件升级
export const deviceUpgrade = params => {
  return Vue.fetch.post('/apiv1/ufo/upgrade', params)
}

// 固件升级历史
export const queryUpgradeHistory = params => {
  return Vue.fetch.post('/apiv1/ufo/queryUpgradeHistory', params)
}

export const refreshData2Device = params => {
  return Vue.fetch.post('/apiv1/hr/employee/device/refreshData2Device', params)
}

export const findBindDevice = params => {
  return Vue.fetch.post('/apiv1/hr/employee/device/findBindDevice', params)
}

export const ufoCount = params => {
  return Vue.fetch.post('/apiv1/ufo/count', params)
}
export const upgradeAll = params => {
  return Vue.fetch.post('/apiv1/ufo/upgradeAll', params)
}

export const upgradeProgress = params => {
  return Vue.fetch.post('/apiv1/ufo/upgradeProgress', params)
}



// WEBPACK FOOTER //
// ./src/services/deviceApi.js